export const Langs = [
  'es'
]



// WEBPACK FOOTER //
// ./src/customization/SelfService/langs.js